
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/square-online-store-builder",
      function () {
        return require("private-next-pages/square-online-store-builder.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/square-online-store-builder"])
      });
    }
  